export interface IApplicationState {
    startRandomWild: boolean
    randomWildsRunning: boolean
    bodyBuilderSelected: boolean
    randomWildsPositions: any
    isFeatureActive: boolean
}

const initialState: IApplicationState = {
    startRandomWild: false,
    randomWildsRunning: false,
    bodyBuilderSelected: true,
    randomWildsPositions: [],
    isFeatureActive: false,
};

export enum actionTypes {
    START_RANDOMWILD = '@@randomWilds/START_RANDOMWILD',
    RANDOM_WILD_RUNNING = '@@randomWilds/RANDOM_WILD_RUNNING',
    CHANGE_CHARACTER = '@@randomWilds/CHANGE_CHARACTER',
    SET_RANDOMWILD_POSITION = '@@randomWilds/SET_RANDOMWILD_POSITION',
    RESET_REEL_STATE = '@@grid/RESET_REEL_STATE',
    FEATURE_IS_ACTIVE = '@@randomWild/FEATURE_IS_ACTIVE',
}

export function reducer(
    state: IApplicationState = initialState,
    action: any,
): IApplicationState {
    const { randomWildsPositions, randomWildsRunning, bodyBuilderSelected, isFeatureActive } = action;

    switch (action.type) {
        case actionTypes.START_RANDOMWILD:
            return {
                ...state,
                startRandomWild: true
            };
        case actionTypes.RANDOM_WILD_RUNNING:
            return {
                ...state,
                randomWildsRunning: randomWildsRunning
            };
        case actionTypes.CHANGE_CHARACTER:
            return {
                ...state,
                bodyBuilderSelected: bodyBuilderSelected
            };
        case actionTypes.SET_RANDOMWILD_POSITION:
            return {
                ...state,
                randomWildsPositions: randomWildsPositions,
                startRandomWild: false,
            };
        case actionTypes.RESET_REEL_STATE:

            return {
                ...state,
                startRandomWild: false,
                randomWildsPositions: []
            }
        case actionTypes.FEATURE_IS_ACTIVE:
            return {
                ...state, isFeatureActive: isFeatureActive
            };
        default:
            return state;
    }
}

export const actions = {
    startRandomWild: (): any => ({ type: actionTypes.START_RANDOMWILD }),
    setRandomWildRunning: (randomWildsRunning: any): any => ({ type: actionTypes.RANDOM_WILD_RUNNING, randomWildsRunning }),
    changeCharacter: (bodyBuilderSelected: any): any => ({ type: actionTypes.CHANGE_CHARACTER, bodyBuilderSelected }),
    setRandomWildPositions: (randomWildsPositions: any): any => ({
        type: actionTypes.SET_RANDOMWILD_POSITION,
        randomWildsPositions
    }),
    featureActive: (isFeatureActive: boolean): any => ({ type: actionTypes.FEATURE_IS_ACTIVE, isFeatureActive }),
};
